// import Auth from '../../Helpers/auth';
const API_URL = process.env.REACT_APP_BACKEND_URL;

// POST: Creates an order for stripe
async function httpCreateOrder({ userId, courseIds }) {
  try {
    return await fetch(`${API_URL}/orders`, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, courseIds }),
    });
  } catch (err) {
    return err;
  }
}
// POST: Creates an order for stripe
async function httpCreateOrderCompany({
  userIds,
  courseIds,
  companyId,
  userId,
  totals,
  discountCode,
}) {
  try {
    return await fetch(`${API_URL}/orders/company`, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userIds,
        courseIds,
        companyId,
        userId,
        totals,
        discountCode,
      }),
    });
  } catch (err) {
    console.log('Error creating company order:', err);
    return err;
  }
}
// GET: Retrieves the checkout session details from stripe
async function httpGetCheckoutSession(sessionId) {
  try {
    return await fetch(`${API_URL}/orders/${sessionId}`, {
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
      },
    });
  } catch (err) {
    return err;
  }
}

// POST: Stripe webhook to handle events like payment success, failure, etc.
async function httpWebhook(eventData) {
  try {
    return await fetch(`${API_URL}/orders/webhook`, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(eventData),
    });
  } catch (err) {
    return err;
  }
}
async function httpCancelTransaction(transactionId) {
  try {
    return await fetch(`${API_URL}/orders/cancel/${transactionId}`, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
    });
  } catch (err) {
    return err;
  }
}

async function httpGetTransactionDetails(sessionId) {
  try {
    return await fetch(`${API_URL}/orders/transaction/${sessionId}`, {
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
      },
    });
  } catch (err) {
    return err;
  }
}

export {
  httpCreateOrder,
  httpCreateOrderCompany,
  httpGetCheckoutSession,
  httpWebhook,
  httpCancelTransaction,
  httpGetTransactionDetails,
};
